/* eslint-disable node/no-unsupported-features/es-syntax */
export const TRACK_ROUTES = [
    {
        path: "/track/:guid",
        name: "public-track",
        component: () => import("../ui/TrackPage.vue"),
        meta: { public: true },
        props: true,
    },
];
